import { render, staticRenderFns } from "./newSwiper.vue?vue&type=template&id=7fa68c1b&scoped=true"
import script from "./newSwiper.vue?vue&type=script&lang=ts"
export * from "./newSwiper.vue?vue&type=script&lang=ts"
import style0 from "./newSwiper.vue?vue&type=style&index=0&id=7fa68c1b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa68c1b",
  null
  
)

export default component.exports